<template>
  <div>
    <template>
      <el-form
        style="margin-top: 26px;"
        :model="form"
        :rules="formRules"
        ref="form"
        label-width="0px"
        label-position="left"
        :disabled="disableForm"
      >
        <!-- username -->
        <div class="el-form-element">
          <el-form-item
            prop="name"
            style="width: 100%"
            class="checkform-form-item"
          >
            <el-input
              name="name"
              ref="input_name"
              :placeholder="$t('scenes.checkout.address.form.name')"
              size="large"
              v-model="form.name"
            >
            </el-input>
          </el-form-item>
        </div>
        <!-- email -->
        <div class="el-form-element">
          <el-form-item
            prop="email"
            style="width: 100%"
            class="checkform-form-item"
          >
            <el-input
              :placeholder="$t('scenes.checkout.address.form.email')"
              ref="input_email"
              name="email"
              size="large"
              v-model="form.email"
            >
            </el-input>
          </el-form-item>
        </div>
        <!-- address line 1 & 2 -->
        <div class="el-form-element">
          <el-form-item class="checkform-form-item">
            <el-col :span="12">
              <el-form-item
                prop="address_line_1"
                class="checkform-form-item"
                :show-message="false"
              >
                <el-input
                  name="address-line1"
                  ref="input_address_line_1"
                  :placeholder="
                    $t('scenes.checkout.address.form.address_line_1')
                  "
                  size="large"
                  v-model="form.address_line_1"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 0.4em;">
              <el-form-item prop="address_line_2" class="checkform-form-item">
                <el-input
                  name="address-line2"
                  :placeholder="
                    $t('scenes.checkout.address.form.address_line_2')
                  "
                  size="large"
                  v-model="form.address_line_2"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <!-- end address 1 & 2 -->
        </div>
        <!-- city -->
        <div class="el-form-element">
          <el-form-item
            prop="address_city"
            style="width: 100%"
            class="checkform-form-item"
            :show-message="false"
          >
            <el-input
              name="address_city"
              :placeholder="$t('scenes.checkout.address.form.address_city')"
              size="large"
              v-model="form.address_city"
            >
            </el-input>
          </el-form-item>
        </div>
        <!-- 3 line - country/state/postal; dynamic; based upon country -->
        <div class="el-form-element">
          <el-form-item class="checkform-form-item">
            <el-col :span="8">
              <el-form-item
                prop="address_country"
                class="checkform-form-item"
                style="padding-right: 0.4em;"
                :show-message="false"
              >
                <el-select
                  v-model="form.address_country"
                  placeholder="Select"
                  @change="onCountryChange"
                >
                  <el-option-group
                    v-for="group in countryGroupSelectOptions.options"
                    :key="group._key"
                    :label="group.label"
                  >
                    <el-option
                      v-for="item in group.options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                prop="address_state"
                class="checkform-form-item"
                :show-message="false"
              >
                <el-select
                  auto-complete="1010101010"
                  v-model="form.address_state"
                  v-if="bShowStateProvinceDropDown"
                  :placeholder="strStateProvinceLabel"
                  filterable
                >
                  <el-option
                    v-for="item in arrStateProvinceSelectOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="bShowStateProvinceDropDown ? 8 : 16">
              <el-form-item
                prop="address_zip"
                class="checkform-form-item"
                style="padding-left: 0.4em;"
                :show-message="false"
              >
                <el-input
                  name="postal-code"
                  :placeholder="strPostalCodeLabel"
                  size="large"
                  v-model="form.address_zip"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
        </div>
      </el-form>
      <slot name="footer"> </slot>
    </template>
    <div class="address-step-footer">
      <div style="float:right">
        <el-icon name="el-icon-loading"></el-icon>
        <el-button
          @click="onClickContinueToPayment"
          type="primary"
          style="width: 200px"
          :disabled="disableForm"
        >
          <i :class="strCheckoutButtonIconClass" style="font-size: 16px"></i>
          Continue to payment
        </el-button>
      </div>
      <div style="float:left">
        <el-button
          type="text"
          @click="onClickReturnToCart"
          :disabled="disableForm"
          ><el-icon name="arrow-left"></el-icon> Return to cart</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import {
  countrySelectOptions,
  generateGroupedSelectDropDown,
  usaStateSelectOptions,
  caProvinceSelectOptions
} from "@/util/ui.js";
export default {
  name: "OrderAddressForm",
  props: {
    name: {
      type: String,
      required: false
    },
    email: {
      type: String,
      required: false
    },
    addressInfo: {
      type: Object
    },
    address_line_1: {
      type: String,
      required: false
    },
    address_line_2: {
      type: String,
      required: false
    },
    address_city: {
      type: String,
      required: false
    },
    address_state: {
      type: String,
      required: false
    },
    address_zip: {
      type: String,
      required: false
    },
    address_country: {
      type: String,
      required: false
    },
    disableForm: {
      type: Boolean,
      require: true
    },
    autoFocusForm: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.form.name = this.name;
    this.form.email = this.email;
    this.form.address_line_1 = this.address_line_1;
    this.form.address_line_2 = this.address_line_2;
    this.form.address_city = this.address_city;
    this.form.address_zip = this.address_zip;
    this.form.address_state = this.address_state;
    this.form.address_country = this.address_country;

    // this scenario is common for a new order, whereby the
    // name & email is auto populated
    if (this.autoFocusForm) {
      if (this.name && this.email && !this.address_line_1) {
        this.$refs["input_address_line_1"].focus();
      } else if (this.name && !this.email) {
        this.$refs["input_email"].focus();
      } else if (!this.name && !this.email) {
        this.$refs["input_name"].focus();
      }
    }
  },
  data() {
    const countryOptions = countrySelectOptions();
    const provinceStateValidator = (rule, value, callback) => {
      const isRequired =
        this.form.address_country === "CA" ||
        this.form.address_country === "US";
      if (isRequired && !value) {
        callback(new Error());
      } else {
        callback();
      }
    };
    return {
      // Here we're going to generate the country dropdown options.
      // For a better UX, we show Canada/USA at the top,
      // in their own group.
      countryGroupSelectOptions: generateGroupedSelectDropDown(
        countryOptions,
        "",
        "",
        ["CA", "US"]
      ),
      form: {
        name: null,
        email: null,
        address_line_1: null,
        address_line_2: null,
        address_city: null,
        address_state: null,
        address_zip: null,
        address_country: "US"
      },
      formRules: {
        name: [
          {
            required: true,
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            message: this.$t(
              "scenes.checkout.address.formErrors.email.required"
            ),
            trigger: "blur"
          },
          {
            type: "email",
            message: this.$t("scenes.checkout.address.formErrors.email.valid"),
            trigger: "blur"
          }
        ],
        address_line_1: [
          {
            required: true,
            trigger: "blur"
          }
        ],
        address_city: [
          {
            required: true,
            trigger: "blur"
          }
        ],
        address_state: [
          {
            validator: provinceStateValidator
          }
        ],
        address_zip: [
          {
            required: true,
            trigger: "blur"
          }
        ],
        address_country: [
          {
            required: true,
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    strPostalCodeLabel() {
      return this.form.address_country === "US"
        ? "Zip"
        : this.form.address_country === "GB"
        ? "Postcode"
        : "Postal Code";
    },
    strStateProvinceLabel() {
      return this.form.address_country === "US"
        ? "State"
        : this.form.address_country === "CA"
        ? "Province"
        : "State";
    },
    strCheckoutButtonIconClass() {
      return this.disableForm ? "el-icon-loading" : "el-icon-bank-card";
    },
    arrStateProvinceSelectOptions() {
      switch (this.form.address_country) {
        case "US":
          return usaStateSelectOptions();
        case "CA":
          return caProvinceSelectOptions();
        default:
          return [];
      }
    },
    bShowStateProvinceDropDown() {
      return (
        this.form.address_country === "CA" || this.form.address_country === "US"
      );
    }
  },
  methods: {
    ...mapActions(["login", "me"]),
    onClickContinueToPayment() {
      this.$refs["form"].validate(valid => {
        console.log(`[AddressForm] is valid: ${valid}`);
        if (valid) {
          this.$emit("evt-address-form-valid", this.form);
        }
      });
    },
    onClickReturnToCart() {
      this.$router.push({ name: "storefront" });
    },
    onCountryChange() {
      // reset state/province dropdown when the country changes, since it is country specific
      this.form.address_state = null;
    }
  }
};
</script>

<style>
.checkform-form-item {
  margin-bottom: 5px;
}
/* this disables the green border effect for form elements which are valid */
.checkform-form-item.el-form-item.is-success .el-input__inner,
.checkform-form-item.el-form-item.is-success .el-input__inner:focus,
.checkform-form-item.el-form-item.is-success .el-textarea__inner,
.checkform-form-item.el-form-item.is-success .el-textarea__inner:focus {
  border-color: #dcdfe6;
}
.address-step-footer {
  margin-top: 30px;
  padding-left: 10px;
  padding-right: 10px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  -webkit-flex-direction: row-reverse;
  -ms-flex-direction: row-reverse;
  flex-direction: row-reverse;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
</style>
